import { get } from "lodash";
import { defaultField, subStringDollarFormat } from "helpers/row-logic-helper";

export const shouldShowGeneralSub = data => true;

export const shouldShowMisc = data => Boolean(get(data, "covenants.financialReportingMisc"));
